import * as React from "react";
import { useCpFormInitialValue, useCpFormValue } from "./utils";

interface Props {
  name: string;
}
export const CpLabelDirtyIndicator: React.FC<Props> = ({ name }) => {
  return null;

  // const initial = useCpFormInitialValue(name);
  // const value = useCpFormValue(name);

  // const isDirty = React.useMemo(() => {
  //   return initial !== value;
  // }, [initial, value]);

  // if (!isDirty) {
  //   return null;
  // }

  // return (
  //   <span
  //     style={{
  //       display: "inline-block",
  //       borderRadius: "100%",
  //       backgroundColor: "var(--color-blue-400)",
  //       transform: "translateY(-1px)",
  //       marginLeft: 4,
  //       width: 8,
  //       height: 8,
  //     }}
  //   />
  // );
};
